import I18n from '@src/i18n';
import styled from '@src/styled-components';
import { Radio, Tree, Checkbox } from 'antd';
import React, { Component } from 'react';



type PropType = {
  processData: any;
  componentsToState: Function;
  recurrency: boolean;
  recurrencyHandler: Function;
  selected: any;
}

type StateType = {
  returnedComponent: any;
  initialPaths: any;
  recurrency?: boolean;
  selectedKeys?: any;
  defaultCheckedKeys: []
}

const SEPARATOR = ' > '
const { TreeNode } = Tree
export default class ComponentsModal extends Component<PropType, StateType> {
  constructor(props: PropType) {
    super(props)

    this.state = {
      returnedComponent: [],
      initialPaths: [],
      recurrency: false,
      selectedKeys: [],
      defaultCheckedKeys: []
    }
  }

  componentDidMount() {
    if (this.props.recurrency) {
      this.setState({ recurrency: this.props.recurrency })
    }
  }
  onSelect = async (selected: any) => {
    await this.props.componentsToState([selected.target.value])
  }
  formatObject = () => {
    let paths = this.props.processData[0].paths
    const returnedArray = []

    for (let singlePath of paths) {
      if (singlePath.value.indexOf('>') === -1) {
        returnedArray.push(singlePath)
      } else {
        let value = singlePath.value
        value = value.split(' > ')
        returnedArray.push({ content: value, key: singlePath.key })
      }
    }
    return returnedArray
  }



  extractPath = (data: any, parentKey?: any) => {

    //I got that i was having a problem with diretcly using the data parameter instead of clonig it
    //but i don't exactly get why
    //TODO: revisit this and understand the problem once I have some time
    const paths = JSON.parse(JSON.stringify(data))
    let initialPaths = paths

    // initialPaths = initialPaths.map((e) => e.value)
    if (parentKey) {
      initialPaths = initialPaths.filter((e) => e.value.startsWith(`${parentKey}${SEPARATOR}`))
    }

    initialPaths = initialPaths.map((e) => {
      if (parentKey) {
        e.label = e.value.slice(parentKey.length + 3)
        e.parentKey = `${parentKey}${SEPARATOR}`
      } else {
        e.label = e.value
        e.parentKey = ''
      }

      e.end = e.label.indexOf(SEPARATOR) === -1
      if (e.end) {
        delete e.parentKey
      } else {
        e.label = e.label.substr(0, e.label.indexOf(SEPARATOR))
        e.parentKey += e.label
      }

      return e
    })
    // remover duplicados
    const labels = initialPaths.map(e => e.label)
    initialPaths = initialPaths.map(e => {
      e.value = e.key
      return e
    })
    initialPaths = initialPaths.filter((e, i) => labels.indexOf(e.label) == i)
    for (let path of initialPaths) {
      if (!path.end) {
        path.children = this.extractPath(paths, path.parentKey)
      }
    }
    return initialPaths
  }

  returnPaths = () => {
    const paths = this.extractPath(this.props.processData[0].paths)
    return (
      <RenderedPaths>
        <Radio.Group onChange={this.onSelect} options={paths} value={this.props.selected ? this.props.selected[0] : undefined} style={{display: 'flex',flexDirection: 'column'}}/>
      </RenderedPaths>
    )
  }

  getSelectedKeys = (items: any, key?: any) => {
    let returnedKeys: any = this.state.defaultCheckedKeys
    for (let i in items) {
      const index = items[i].end ? items[i].key : i
      const newKey = key ? `${key}-#${index}` : index
      if (this.props.selected) {
        for (let item of this.props.selected) {
          if (item === items[i].key) {
            returnedKeys.push(newKey)
            break;
          }
        }
      }

      if (items[i].children) {
        this.getSelectedKeys(items[i].children, newKey)
      }

    }
    returnedKeys = returnedKeys.filter((item: string, pos: number) => returnedKeys.indexOf(item) == pos)
    return returnedKeys
  }

  recurrencyHandler = async (e: any) => {
    this.props.recurrencyHandler(e.target.checked)
    this.setState(prevState => ({ recurrency: !prevState.recurrency }))
  }

  render() {
    this.extractPath(this.props.processData[0].paths)
    return (
      <Wrapper>
        <Header>
          <h3>{I18n.l('formflow.components.title')}</h3>
          <p>{I18n.l('lite.dashboard.select.components')}</p>
          <Checkbox className="recurrence-checkbox" onChange={this.recurrencyHandler} checked={this.state.recurrency}>{I18n.l('components.modal.recurrence')}</Checkbox>
        </Header>
        <Content>
          {this.returnPaths()}
        </Content>
      </Wrapper>
    )
  }
}

const Wrapper = styled.div`
display: flex;
flex-direction: column;
`

const Header = styled.div`

.recurrence-checkbox {
    font-weight: bold;
    margin: 10px 0;
  }
`

const Content = styled.div`
display: flex;
flex-direction: column;
border-radius: 5px;
background-color: #F9F9F9;
width: 95%;

.ant-tree-node-content-wrapper{
  display: inline-block;
    padding: 0 5px;
    border-radius: 2px;
    margin: 0;
    cursor: pointer;
    text-decoration: none;
    vertical-align: top;
    color: rgba(0, 0, 0, 0.65);
    transition: all .3s;
    height: auto !important;
    line-height: 24px;
    white-space: normal;
    max-width: 90%;
}
`

const RenderedPaths = styled.div`
  label{
    padding: 5px;
  }
`